import React from 'react';

export const HamburgerIcon = ({ isOpen }) => (
  <div className="w-6 h-5 md:w-7.5 md:h-6 relative flex items-center justify-center">
    <span
      className={`absolute w-6 md:w-7.5 h-[2px] bg-[#F5E6D8] transition-all duration-300 transform ${
        isOpen ? 'rotate-45 translate-y-0' : '-translate-y-[5.5px] md:-translate-y-[7.5px]'
      }`}
    />
    <span
      className={`absolute w-6 md:w-7.5 h-[2px] bg-[#F5E6D8] transition-all duration-300 transform ${
        isOpen ? 'opacity-0 scale-0' : 'opacity-100 scale-100'
      }`}
    />
    <span
      className={`absolute w-6 md:w-7.5 h-[2px] bg-[#F5E6D8] transition-all duration-300 transform ${
        isOpen ? '-rotate-45 translate-y-0' : 'translate-y-[5.5px] md:translate-y-[7.5px]'
      }`}
    />
  </div>
);

export const SearchIcon = () => (
  <svg className="w-[19.9px] h-[19.9px] md:w-[23.5px] md:h-[23.5px] text-[#F5E6D8]" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const UserIcon = () => (
  <svg className="w-[19.9px] h-[19.9px] md:w-[23.5px] md:h-[23.5px] text-[#F5E6D8]" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const CartIcon = () => (
  <svg className="w-[19.9px] h-[19.9px] md:w-[23.5px] md:h-[23.5px] text-[#F5E6D8]" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <rect x="5" y="8" width="14" height="13" rx="2" />
    <path d="M9 8V6a3 3 0 0 1 6 0v2" />
  </svg>
);

export const CloseIcon = () => (
  <svg className="w-6 h-6 text-[#584738]" fill="none" stroke="currentColor" strokeWidth="1.25" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const HeartIcon = ({ 
  filled = false, 
  className = "w-5 h-5", 
  activeColor = "#E11D48", 
  inactiveColor = "currentColor" 
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill={filled ? activeColor : "none"}
    stroke={filled ? activeColor : inactiveColor}
    strokeWidth={filled ? "1.5" : "1.75"}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`${className} transition-all duration-300 ease-in-out transform ${
      filled ? "scale-110" : "scale-100"
    }`}
    style={{
      transition: 'fill 0.3s ease-in-out, stroke 0.3s ease-in-out, transform 0.3s ease-in-out'
    }}
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);
